/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Session_Any_DayInputs */

const en_us2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any day`)
};

const pt_br2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia livre`)
};

const es_419_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier día`)
};

const pt_pt2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia livre`)
};

const fr_fr2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour libre`)
};

const de_de2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freier Tag`)
};

const it_it2_plan_session_any_day = /** @type {(inputs: Plan_Session_Any_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorno libero`)
};

/**
* | output |
* | --- |
* | "Any day" |
*
* @param {Plan_Session_Any_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_any_day = /** @type {((inputs?: Plan_Session_Any_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_Any_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_any_day(inputs)
	if (locale === "es-419") return es_419_plan_session_any_day(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_any_day(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_any_day(inputs)
	if (locale === "de-DE") return de_de2_plan_session_any_day(inputs)
	if (locale === "it-IT") return it_it2_plan_session_any_day(inputs)
	return en_us2_plan_session_any_day(inputs)
});
export { plan_session_any_day as "plan.session_any_day" }